<template>
    <div class="login-container">
        <div class="login-card">
            <div class="login-header">
                              <div class="d-flex justify-content-center my-4">
                <img class="w-20" src="/img/mcp_bildmarke.svg" alt="MyChatPro-Bildmarke">
              </div>
                <h1 class="login-title">MyChatPro</h1>
                <h4 class="login-subtitle">Login</h4>
            </div>

            <div v-if="$page.props.status === 'verification-required'" 
                 class="alert alert-warning">
                Bitte verifiziere deine E-Mail-Adresse, bevor du dich einloggst.
                Schau in deinen E-Mails nach einem Verifizierungslink.
            </div>

            <div v-if="$page.props.status === 'verification-success'" 
                 class="alert alert-success">
                Deine E-Mail-Adresse wurde erfolgreich verifiziert. Du kannst dich jetzt einloggen.
            </div>

            <form @submit.prevent="submit" class="login-form">
                <div class="form-group">
                    <label for="email" class="form-label">Email</label>
                    <input 
                        v-model="form.email" 
                        id="email" 
                        type="email" 
                        class="form-control" 
                        required 
                        autofocus 
                        autocomplete="username"
                    >
                    <div v-if="form.errors.email" class="error-message">
                        {{ form.errors.email }}
                    </div>
                </div>

                <div class="form-group">
                    <label for="password" class="form-label">Passwort</label>
                    <input 
                        v-model="form.password" 
                        id="password" 
                        type="password" 
                        class="form-control" 
                        required 
                        autocomplete="current-password"
                    >
                    <div v-if="form.errors.password" class="error-message">
                        {{ form.errors.password }}
                    </div>
                </div>

                <div class="form-check">
                    <input 
                        type="checkbox" 
                        v-model="form.remember" 
                        class="form-check-input" 
                        id="remember"
                    >
                    <label class="form-check-label" for="remember">
                        Eingeloggt bleiben
                    </label>
                </div>

                <div v-if="form.errors.auth" class="error-message">
                    {{ form.errors.auth }}
                </div>

                <div class="form-actions">
                    <a href="/forgot-password" class="forgot-password-link">
                        Passwort vergessen?
                    </a>

                    <button 
                        type="submit"
                        class="btn btn-primary" 
                        :class="{ 'opacity-25': form.processing }" 
                        :disabled="form.processing"
                    >
                        Anmelden
                    </button>
                </div>

                <div class="register-link">
                    <span>Hast du noch kein Konto?</span>
                    <a :href="route('registrieren')" class="register-link-text">
                        Jetzt registrieren
                    </a>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import { useForm} from '@inertiajs/vue3';



const props = defineProps({
    //canResetPassword: Boolean,
    //status: String,
});

const form = useForm({
    email: '',
    password: '',
    remember: false,
});

const submit = () => {
    form.post(route('login'), {
        onFinish: () => {
            form.reset('password');
        },
        preserveState: true,
    });
};
</script>
